import { animate, style, transition, trigger } from '@angular/animations';

export const routeTransitionAnimations = trigger('triggerName', [
  transition('* => Child', [
    style({ transform: 'translateY(100%)' }),
    animate('0.2s ease', style({ transform: 'translateY(0%)' })),
  ]),
]);
